/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PostCollaborationToolTemplateTestRequestDto = {
    type: PostCollaborationToolTemplateTestRequestDto.type;
};

export namespace PostCollaborationToolTemplateTestRequestDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
